import { ProjectSummaryReportComponent } from './../report/project-summary-report/project-summary-report.component';
import { Injectable } from '@angular/core';
import { InjectionToken } from '@angular/core';
import { Inject } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DOCUMENT } from '@angular/common';

import { Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ReportService {
  url: string;

  constructor(private http: HttpClient,
    private toastr: ToastrService,
    private router: Router,
    private cookieService: CookieService,
    @Inject( DOCUMENT ) private document: Document

  )
   {
    this.url=environment.baseUrl;
   }
  ///HuLoopRest/huloop/testReport/projectReport/61276af0a1f486a24017af51/1640975400000/1642616999999/All/All/false
  getProjectReport( projectId,fromDate,toDate,browser,os, iterationCount){
    return  this.http.get(this.url + '/HuLoopRest/huloop/testReport/projectReport/' + projectId + '/' + fromDate + '/'+toDate +'/'+browser+'/'+os+'/false')
   }

//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/testReport/projectTestDataDetailSummary/61276af0a1f486a24017af51/1640975400000/1642616999999/All/All
   getProjectSummryDetail( projectId){
     
    return  this.http.get(this.url + '/HuLoopRest/huloop/testReport/projectTestDataDetailSummary/' + projectId + '/1640975400000/1642616999999/All/All')
  
   }
    getProjectReportWithIterationCount(projectId){
      
      return  this.http.get(this.url + '/HuLoopRest/huloop/testReport/projectReport/' + projectId + '/1640975400000/1642616999999/All/All/true')
 
    }

    getLocatorHistory(projectId,fromDate, toDate,count)
    {
      return this.http.get(this.url + '/HuLoopRest/huloop/loggingResource/' + projectId + '/' + fromDate + '/' + toDate + '/editLocatorStep/' + count)
    }
    getTestHistory(projectId,fromDate, toDate,count)
    {
      return this.http.get(this.url + '/HuLoopRest/huloop/loggingResource/' + projectId + '/' + fromDate + '/' + toDate + '/editTestStep/' + count)
    }
  getExecutionReport(projectId,fromDate,toDate,status,suite){
  return this.http.get(this.url+'/HuLoopRest/huloop/testReport/executionReport/'+projectId + '/' + fromDate + '/' + toDate + '/' +status +'/'+suite+'/'+null)
    }
    getrunSettingExecutionReport(projectId,fromDate,toDate,status,suite,settingName){
      return this.http.get(this.url+'/HuLoopRest/huloop/testReport/executionReport/'+projectId + '/' + fromDate + '/' + toDate + '/' +status +'/'+suite +'/'+ settingName)
    }
    shareReport(projectId,reportId,testDataId,iteration,list){

     return this.http.post(this.url + '/HuLoopRest/huloop/testReport/shareReport/' + projectId + '/'+reportId +'/' + testDataId +'/'+ iteration,list)
      //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/testReport/shareReport/6204b81860b2a68e69d55df1/6213366160b2aacb6f65aa2b/6204b81960b2a68e69d55dfc,0/0
    }
    projectDetailSummary(projectId,fromDate,toDate,browser,os){
      return  this.http.get(this.url + '/HuLoopRest/huloop/testReport/projectTestDataDetailSummary/' + projectId + '/' + fromDate + '/'+toDate +'/'+browser+'/' + os)
    }
//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/testReport/projectTestCaseExecutionSummary/6204b81860b2a68e69d55df1/1643653800000/1647541799999/All/All/6204b81860b2a68e69d55df7
projectTestCaseExecutionSummary(projectId,fromDate,toDate,browser,os,suiteId){
  return  this.http.get(this.url + '/HuLoopRest/huloop/testReport/projectTestCaseExecutionSummary/' + projectId + '/' + fromDate + '/'+toDate +'/'+browser+'/' + os + '/' +suiteId)
}

//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/testReport/testCaseHistory/6204b81860b2a68e69d55df1/1643653800000/1647541799999/All/All/6204b81960b2a68e69d55e020/6204b81860b2a68e69d55df7
  
testCaseHistory(projectId,fromDate,toDate,browser,os,caseId,suiteId){
  return  this.http.get(this.url + '/HuLoopRest/huloop/testReport/testCaseHistory/' + projectId + '/' + fromDate + '/'+toDate +'/'+browser+'/' + os + '/'+caseId +'/'+suiteId)
}

//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/testSuiteData/6204b81860b2a68e69d55df1/6204b81860b2a68e69d55df7
getTestSuiteReport(projectId, suiteId){
  return this.http.get(this.url+'/HuLoopRest/huloop/test/testSuiteData/' + projectId + '/' + suiteId)
}

//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/testReport/historyReport/6204b81860b2a68e69d55df1/1640250004185/1648060199000/ALL/6204b81860b2a68e69d55df1
getHistoryReport(projectId,fromDate,toDate,browser){
return this.http.get(this.url+'/HuLoopRest/huloop/testReport/historyReport/'+projectId+'/'+fromDate + '/'+toDate +'/'+browser +'/'+ projectId)
}

//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/testReport/stepsExecutionInfo/6204b81860b2a68e69d55df1/6213381c60b2aacb6f65aa4f
getStepExecutionInfo(projectId,suiteId){
 return this.http.get(this.url+'/HuLoopRest/huloop/testReport/stepsExecutionInfo/'+projectId + '/' + suiteId)
}


failureReason(projectid,testProjectReportId,testDataId,path): Observable<any> {
  return this.http.get(this.url+ '/HuLoopRest/huloop/testReport/testCase/'+ projectid + '/' + testProjectReportId + '/' + testDataId + '/0/' + path)
}

projectSummaryReport(projectId,startDate,endDate,status) : Observable<any>{
  return this.http.get(this.url + '/HuLoopRest/huloop/testReport/projectTCStatusSummary/'+projectId+'/'+startDate+'/'+endDate+'/All/All/'+status+'/false');
}
tagExecutionReport(projectId,startDate,endDate,status,tag){

  return this.http.get(this.url + '/HuLoopRest/huloop/testReport/tagExecutionReport/'+projectId+'/'+startDate+'/'+endDate+'/'+status+'/'+tag);
 }

tagTestCaseReport(projectId,reportId){
  return this.http.get(this.url + '/HuLoopRest/huloop/testReport/tagTCReport/'+projectId+'/'+reportId+'/ALL/ALL');
}
getTestProjectReport(projectId, testPrjRepId, testCaseId, dataIId, path): Observable<any> {
  return this.http.get(this.url + '/HuLoopRest/huloop/testReport/testCase/'+projectId+'/'+testPrjRepId+'/'+testCaseId+'/'+dataIId+'/'+path);
}
getrunSetting(projectId){
  return this.http.get(this.url+'/HuLoopRest/huloop/webRunSetting/' +projectId )
}
}

